import React from "react";
import {connect} from "react-redux";
import axios from "axios";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {Typography, Paper, Button} from "@material-ui/core";
import {ArrowDownward} from '@material-ui/icons';
import {INewParcelaSection, INotificacion, IParcela, ISections} from "../../../types";
import {userService} from "../../../services/UserService";

const config = require('../../../config.json');


interface IProps {
    seccion: INewParcelaSection
    nombre: string
    propietario: string
    parcela: IParcela
    notify(notification: INotificacion): void
    selectPropiedadesSection(seccion: INewParcelaSection): void
    setParcelas(parcelas: IParcela[]): void
    selectSection(section: ISections): void
    openConfirmacion(callback: string): void
}

interface IState {
}

class Estado extends React.Component<IProps, IState> {
    state: IState = {
    }

    actualizar = () => {
        try {
            if (this.props.nombre !== this.props.parcela.nombre) return true
            if (this.props.propietario !== this.props.parcela.propietario) return true
            return false
        } catch (e) {
            return false
        }
    }


    handleUpdate = () => {
        axios.post(
            config.url+'/actualizar/parcela',
            {
                id: this.props.parcela.id,
                nombre: this.props.nombre,
                propietario: this.props.propietario
            },
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }
            })
            .then(() => {
                axios.get(
                    config.url+'/init',
                    {auth: {
                            username: `${userService.getUser()}`,
                            password: `${userService.getPass()}`
                        }})
                    .then((res: { data: IParcela[] }) => {
                        this.props.setParcelas(res.data)
                        this.props.selectSection('principal')
                        this.props.notify({message: 'Cambios guardados correctamente', variant: 'success'})
                    })
                    .catch(() => {})
            })
            .catch(() => {})
    }

    render () {
        return (
            <Paper style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: "center",
                width: '100%',
                height: '100%'
            }}>
                <Button
                    variant={"outlined"}
                    style={{
                        marginTop: 20,
                        textTransform: "none",
                        width: '90%',
                        backgroundColor: this.props.seccion === 'Caracterización'? "#aaaaaa" : "#fff"
                    }}
                    onClick={() => this.props.selectPropiedadesSection('Caracterización')}
                >
                    <Typography>
                        Caracterización
                    </Typography>
                </Button>

                <ArrowDownward style={{margin: 10}}/>

                <Button
                    variant={"outlined"}
                    style={{
                        textTransform: "none",
                        width: '90%',
                        backgroundColor: this.props.seccion === 'Ubicación'? "#aaaaaa" : "#fff"
                    }}
                    onClick={() => this.props.selectPropiedadesSection('Ubicación')}
                >
                    <Typography>
                        Ubicación
                    </Typography>
                </Button>

                <ArrowDownward style={{margin: 10}}/>

                <Button
                    variant={"outlined"}
                    style={{
                        textTransform: "none",
                        width: '90%',
                        backgroundColor: this.props.seccion === 'Sectores'? "#aaaaaa" : "#fff"
                    }}
                    onClick={() => this.props.selectPropiedadesSection('Sectores')}
                >
                    <Typography>
                        Sectores
                    </Typography>
                </Button>

                <ArrowDownward style={{margin: 10}}/>

                {this.actualizar() && this.props.nombre.length > 0&&
                <Button
                    variant={"contained"}

                    style={{
                        textTransform: "none",
                        width: '90%',
                        backgroundColor: '#257b28',
                        marginTop: 20
                    }}
                    onClick={() => this.handleUpdate()}
                >
                    <Typography style={{fontWeight: "bold", color: "white"}}>
                        GUARDAR CAMBIOS
                    </Typography>
                </Button>
                }
                <Button
                    variant={"contained"}
                    style={{
                        textTransform: "none",
                        width: '90%',
                        backgroundColor: "#bb1515",
                        marginTop: 20
                    }}
                    onClick={() => {
                        this.props.openConfirmacion(this.props.parcela.id)
                    }}
                >
                    <Typography style={{fontWeight: "bold", color: "white"}}>
                        ELIMINAR PARCELA
                    </Typography>
                </Button>

            </Paper>
        )
    }

}


const mapStateToProps = (state: IStore) => ({
    seccion: state.propiedades.seccion,
    nombre: state.propiedades.nombre,
    propietario: state.propiedades.propietario,
    parcela: state.propiedades.parcela
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    selectPropiedadesSection: (seccion: INewParcelaSection) => dispatch({type: "select-propiedades-seccion", seccion}),
    setParcelas: (parcelas: IParcela[]) => dispatch({type: "set-principal-parcelas", parcelas}),
    selectSection: (section: ISections) => dispatch({type: "select-section", section}),
    openConfirmacion: (callback: string) => dispatch({type: "open-confirmacion-eliminar-dialog", callback})
});

export default connect(mapStateToProps, mapDispatchToProps)(Estado);
